module.exports = __webpack_public_path__ + "24887a8a6d88d7abd8abe8d08d3b4460.svg";